module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileName",
      "sortable": "custom",
      "label": _vm.$t('app_filename'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileType",
      "formatter": _vm.setft,
      "width": "115",
      "label": _vm.$t('app_filetype')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "subFileType",
      "formatter": _vm.setsbt,
      "width": "120",
      "label": _vm.$t('app_subtype')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileStatus",
      "width": "115",
      "label": _vm.$t('app_status')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          style: (_vm.getStatus(scope.row.fileStatus).style)
        }, [_vm._v(_vm._s(_vm.getStatus(scope.row.fileStatus).vl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "createTime",
      "width": "175",
      "label": _vm.$t('app_addtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "operate",
      "width": "84",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_verify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_c('i', {
          staticClass: "fa fa-check-square-o"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0522d01c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/file/vlist.vue
// module id = 954
// module chunks = 0